<template>
  <section class="subscDescriptionWrap">
    <div class="subscDescription">
      <!-- <div class="subscDescription__head subscDescription__head--ls" v-if="isSubscRegist">会員の特典</div> -->
      <div class="subscDescription__head">
        <span class="subscDescription__head__title">占いTV</span>
        <span class="subscDescription__head__price">
          月額<b>¥{{ subscPrice | addComma }}</b>(税込)
        </span>
      </div>

      <div v-if="description.length > 0 && !isRejoin && !paymentMethod" class="subscDescription__tokutenWrap">
        <div v-for="item in description" :key="item.label" class="subscDescription__tokuten">
          <span v-if="item.label" class="subscDescription__tokuten__label">{{ item.label }}</span>
          <span v-html="item.body"></span>
        </div>
        <div>
          ※商品のご提供時期、お支払い時期・キャンセルについては<a href="/legal" target="_blank">こちら</a>をご確認ください。<br>※月額の解約は、<a href="/faq" target="_blank">こちら</a>をご確認ください。
        </div>
      </div>
      <dl v-else-if="paymentMethod" class="subscDescription__payment">
        <dt>お支払い方法</dt>
        <dd>{{ paymentMethod }}</dd>
      </dl>
    </div>
    <!--
    <span v-if="description.length > 0 && !isRejoin && isSubscTrial" class="subscDescription__attention">
      ※無料期間終了後は、月額利用料{{ subscPrice | addComma }}円（税込）がかかります。<br>
      ※特典は無料期間終了後にお申し込みいただけます。
    </span>
    -->
  </section>
</template>


<script>

export default {
  name: 'subscDescription',
  props: {
    subscPrice:{
      type:Number,
      default:0
    },
    // サブスクの再開かどうか
    isRejoin: {
      type: Boolean,
      default: false,
    },
    // サブスクのお試し2週間無料が有効か
    isSubscTrial: {
      type: Number,
      default: 1,
    },
    // お支払い方法
    paymentMethod: {
      type: String,
      default: '',
    },
    // サブスク初回登録時
    isSubscRegist: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      /*
      description: [
        {label:'お試し',body:'2週間無料'},
        {label:'特典1',body:'入会時に500ポイントプレゼント'},
        {label:'特典2',body:'動画占いを毎月1本プレゼント'}
      ],
       */
      description: [
        {label:'',body:'2000メニュー以上の占いが利用可能'},
        {label:'特典1',body:'大ボリューム3000字！2023年の運勢が通常価格999円→会員価格500円で占える'},
        {label:'特典2',body:'動画占いが毎月1本<strong>無料</strong>'},
        {label:'特典3',body:'暮れの酉、法演、斗弥、叶ここの豪華鑑定（通常888円）が<strong>無料</strong>'},
        // {label:'特典3',body:'占いTV内で使える<strong>500ポイント</strong>プレゼント'}
      ],
    }
  },
  created() {
    if (this.isRejoin) this.description = []
    // if (!this.isSubscTrial) this.description.splice(0, 1)
  },
}
</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";

.subscDescription{
  color: $col_base_black;
  background: linear-gradient(81.44deg, rgba(#FF7497, 0.07) 21.4%, rgba(#CB8BFF, 0.07) 76.64%);
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  mix-blend-mode: multiply;
  border-radius: 7px;
  padding: 15px 12px;;
  font-size: 12px;
  line-height: 20px;
  @include mq('w580'){
    font-size: 16px;
    line-height: 26px;
    padding: 20px 40px;
  }

  &__head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--ls {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      justify-content: center;
    }

    &__title{
      color: $col_normal_font;
    }

    &__price{
      font-size: 11px;
      b {
        font-size: 18px;
        padding-left: 1px;
      }
    }
  }

  &__tokutenWrap{
    margin-top: 14px;
    padding-top: 14px;
    border-top: 1px solid;
    border-image: linear-gradient(to right, $col_temp_key1 0%, $col_temp_key2 100%);
    border-image-slice: 1;
    border-left: 0px;
    border-right: 0px;
    border-bottom: 0px;
    &.no-border {
      border: none;
      margin-top: 0;
    }
  }

  &__tokuten{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    /deep/ {
      strong{
        color: #ee7d97;
        font-weight: bold;
      }
    }
    &--utvmess{
      display: inline-block;
      position: relative;
      padding-left: 54px;
      line-height: 16px;
      margin-top: 4px;
      &::before {
        content: "";
        background: url(/static/img/common/utv_logo_label.svg?v1.1) no-repeat center center;
        background-size: 100% auto;
        width: 38px;
        height: 20px;
        position: absolute;
        top: 0;
        left: 4px;
        margin: auto;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }

    &__label{
      padding: 2px 8px;
      background: $col_def_gradient;
      border-radius: 10px;
      font-size: 10px;
      line-height: 15px;
      color: white;
      font-weight: bold;
      margin-right: 8px;
      min-width: 46px;
      text-align: center;
    }
  }

  &__attention{
    font-size: 11px;
    line-height: 16px;
    color: $col_base_black;
    margin-top: 8px;
    display: block;
  }
  &__payment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 14px 0 0;
    padding: 19px 0 5px;
    border-top: 1px solid;
    border-image: linear-gradient(to right, $col_temp_key1 0%, $col_temp_key2 100%);
    border-image-slice: 1;
    border-width: 1px 0 0;
    dt {
      color: $col_normal_font
    }
    dd {
      margin: 0;
      font-size: 11px;
      font-weight: bold;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SubscDescription.vue